import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, CardHeader, CardBody } from "../Card"
import ToggleSwitch from '../ToggleSwitch'
import actions from '../../actions/index'
import { currentUtcDateTime } from '../../utils/dateTime'

class MajorDealPaddle extends Component {
  state = {
    checked: this.props.defaultChecked
  }; 

  saveDealAlertPreference = (currentDealAlert) => {
    let newAlertPreferences = this.props.preferences.alertPreferences.map(element => element.id == this.props.id ? {...element, majorDealPreference : currentDealAlert, dateModified : currentUtcDateTime()} : element); 
    const request = () => {      
      return {
        ...this.props.preferences,
        alertPreferences: newAlertPreferences
      }
    }
    // this.props.alertPreference.majorDealPreference = currentDealAlert
    this.props.onSubmit(request())
  }

  render () {    
    let dealAlertSwitchId = `tsDealAlert${this.props.id}`
    
    return (      
      <div className={'paddle deal_paddle' + ( this.props.alertPreference.majorDealPreference ? ' alert_enabled' : ' alert_disabled') }>
        <Card>
          <CardHeader>
            <span className='deal_paddle_name'>{this.props.name}</span>
            <span className='deal_alert'>
              <ToggleSwitch id={dealAlertSwitchId} Name={dealAlertSwitchId} defaultChecked={this.props.alertPreference.majorDealPreference} apiCallFunc={this.saveDealAlertPreference} 
              datagmupn='personalize'
              datagmuc='alerts'
              datagmue='drmajordeals_toggle'
              datagmua='click'/>
            </span>          
          </CardHeader>
          <CardBody>
            <div className="card_body_row">
              <div className="items_wrapper">
                <span className='category_text'>Receive one email containing the full text of a single major deal article, the moment it is published.</span>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {    
    preferences: state.userPreferences
  }
}

const mapDispatchToProps = (dispatch) => ({  
  onSubmit(request) {
    dispatch(actions.updatePreferences(request))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MajorDealPaddle)
